import { render, staticRenderFns } from "./ms-drug-show.vue?vue&type=template&id=8c01c242&scoped=true"
import script from "./ms-drug-show.vue?vue&type=script&lang=js"
export * from "./ms-drug-show.vue?vue&type=script&lang=js"
import style0 from "./ms-drug-show.vue?vue&type=style&index=0&id=8c01c242&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c01c242",
  null
  
)

export default component.exports